import {
    SET_SELECTED_CHALLENGE,
    SET_SELECTED_CHALLENGE_ID,
    TOP_CONTRIBUTORS_REQUESTED,
    TOP_CONTRIBUTORS_SUCCEEDED,
    TOP_CONTRIBUTORS_FAILED,
    CHANGE_TEAM_MODE,
    TOP_TAGS_REQUESTED,
    TOP_TAGS_SUCCEEDED,
    TOP_TAGS_FAILED,
    SEGMENTS_LIST_REQUESTED,
    SEGMENTS_LIST_SUCCEEDED,
    SEGMENTS_LIST_FAILED,
    SEGMENT_TAGS_REQUESTED,
    SEGMENT_TAGS_SUCCEEDED,
    SEGMENT_TAGS_FAILED,
    SET_SELECTED_SEGMENT,
    IMPACT_FILTER_REQUESTED,
    IMPACT_FILTER_SUCCEEDED,
    IMPACT_FILTER_FAILED,
    SPECIFIC_CHALLENGE_REQUESTED,
    SPECIFIC_CHALLENGE_SUCCEEDED,
    SPECIFIC_CHALLENGE_FAILED,
    CONNECTED_CHALLENGE_REQUESTED,
    CONNECTED_CHALLENGE_SUCCEEDED,
    CONNECTED_CHALLENGE_FAILED,
    CHALLENGE_CODES_REQUESTED,
    CHALLENGE_CODES_SUCCEEDED,
    CHALLENGE_CODES_FAILED,
    SET_PARENT_CHALLENGE,
    CHALLENGE_NOTIFICATIONS_REQUESTED,
    CHALLENGE_NOTIFICATIONS_FAILED,
    CHALLENGE_NOTIFICATIONS_SUCCEEDED,
    ADD_CHALLENGE_NOTIFICATION_REQUESTED,
    ADD_CHALLENGE_NOTIFICATION_SUCCEEDED,
    ADD_CHALLENGE_NOTIFICATION_FAILED,
    CHALLENGE_NOTIFICATION_RESET,
    NOTIFICATION_LIMIT,
    ADD_CHALLENGE_CODE_REQUESTED,
    ADD_CHALLENGE_CODE_SUCCEEDED,
    ADD_CHALLENGE_CODE_FAILED,
    UPDATE_CHALLENGE_CODE_REQUESTED,
    UPDATE_CHALLENGE_CODE_SUCCEEDED,
    UPDATE_CHALLENGE_CODE_FAILED,
    CLEAR_CHALLENGE_CODE_ERROR,
} from './constants';

const initialState = {
    // initialize empty array for top contributiors
    topContributors: [],
    codeId: '',
    // initialize boolean to represent topContributors loading state
    contributorsLoading: false,
    // initialize empty arrays for user and ml generated top tags
    topTags: { mlTags: [], userTags: [] },
    // initialize boolean to represent topTags loading state
    tagsLoading: false,
    // initialize integer value for total tags
    totalTags: 0,
    // initialize empty string for selected taxonomy
    taxonomy: '',
    // initialize empty string for selected date
    date: '',
    // initialize empty array for segments
    segments: [],
    // initialize empty array for segment tags
    segmentTags: { mlTags: [], userTags: [] },
    // initialize value for total segment tags
    segmentTotalTags: 0,
    // initial state of segment to fetch segment tags for
    segmentId: null,
    // initialize boolean to represent segment tags loading state
    segmentTagsLoading: false,
    // intialize empty string for selected taxonomy in segment tags
    segmentTaxonomy: 'category',
    // initial state of challenge to fetch segments for
    challengeId: null,
    // initialize boolean to represent segments loading state
    segmentsLoading: false,
    // Limits the number of segments being fetched
    segmentsLimit: 10,
    // initial state of error
    error: null,
    // denotes the selected challenge
    challenge: {},
    // challenge loading state
    challengeRequested: false,
    // denotes the currently selected impact box filter radio option
    selectedFilter: null,
    // The litters to be shown on map
    impactLitters: [],
    // indicates whether the litters have been requested or not
    litterRequested: true,
    notifications: [],
    notificationCurrentPage: 0,
    hasMoreNotifications: true,
    addingNewCode: false,
    updatingCode: false,
    updatingError: '',
};

export default function(state = initialState, action) {
    switch (action.type) {
        case CLEAR_CHALLENGE_CODE_ERROR: {
            return {
                ...state,
                updatingError: '',
                codeAddingError: '',
            };
        }
        case UPDATE_CHALLENGE_CODE_REQUESTED: {
            return {
                ...state,
                error: null,
                updatingError: '',
                updatingCode: true,
            };
        }
        case UPDATE_CHALLENGE_CODE_SUCCEEDED: {
            return {
                ...state,
                updatingError: '',
                updatingCode: false,
            };
        }
        case UPDATE_CHALLENGE_CODE_FAILED: {
            const { error } = action;
            return {
                ...state,
                updatingError: error,
                updatingCode: false,
            };
        }

        case SET_SELECTED_CHALLENGE_ID: {
            const { challengeId } = action;
            return {
                ...state,
                challengeId,
                segmentsLimit: 10,
            };
        }
        case SET_SELECTED_CHALLENGE: {
            const { challenge } = action;
            return {
                ...state,
                challenge,
                segmentsLimit: 10,
            };
        }
        case SET_SELECTED_SEGMENT: {
            const { segmentId } = action;
            return { ...state, segmentId };
        }
        case TOP_CONTRIBUTORS_REQUESTED: {
            const { date, customDate } = action;
            return {
                ...state,
                date,
                customDate,
                contributorsLoading: true,
            };
        }
        case TOP_CONTRIBUTORS_SUCCEEDED: {
            const { topContributors } = action;
            return {
                ...state,
                topContributors,
                contributorsLoading: false,
            };
        }
        case TOP_CONTRIBUTORS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                contributorsLoading: false,
            };
        }
        case CHANGE_TEAM_MODE: {
            return {
                ...state,
                codeId: action.codeId,
            };
        }
        case TOP_TAGS_REQUESTED: {
            const { taxonomy } = action;
            return {
                ...state,
                taxonomy,
                totalTags: [],
                totalMlTags: 0,
                totalDistilledTags: 0,
                topTags: {},
                tagsLoading: true,
            };
        }
        case TOP_TAGS_SUCCEEDED: {
            const { topTags } = action;
            return {
                ...state,
                ...topTags,
                tagsLoading: false,
            };
        }
        case TOP_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                tagsLoading: false,
            };
        }
        case SEGMENTS_LIST_REQUESTED: {
            const { segmentsLimit } = action;
            return {
                ...state,
                segmentsLoading: true,
                segmentsLimit,
            };
        }
        case SEGMENTS_LIST_SUCCEEDED: {
            const { segments } = action;
            return {
                ...state,
                segments,
                segmentsLoading: false,
            };
        }
        case SEGMENTS_LIST_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                segmentsLoading: false,
            };
        }
        case SEGMENT_TAGS_REQUESTED: {
            const { segmentTaxonomy } = action;
            return {
                ...state,
                segmentTaxonomy,
                segmentTagsLoading: true,
            };
        }
        case SEGMENT_TAGS_SUCCEEDED: {
            const { segmentTags } = action;
            return {
                ...state,
                segmentTags: {
                    ...segmentTags,
                },
                segmentTagsLoading: false,
            };
        }
        case SEGMENT_TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                segmentTagsLoading: false,
            };
        }
        case IMPACT_FILTER_REQUESTED: {
            const { selectedFilter } = action;
            return {
                ...state,
                selectedFilter,
                litterRequested: true,
            };
        }
        case IMPACT_FILTER_SUCCEEDED: {
            const { impactLitters } = action;
            return {
                ...state,
                litterRequested: false,
                impactLitters,
            };
        }
        case IMPACT_FILTER_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                litterRequested: false,
            };
        }
        case SPECIFIC_CHALLENGE_REQUESTED: {
            const { challengeId } = action;
            return {
                ...state,
                challengeId,
                error: null,
                challenge: {},
                codeAddingError: '',
                challengeRequested: true,
            };
        }
        case SPECIFIC_CHALLENGE_SUCCEEDED: {
            const { challenge } = action;
            return {
                ...state,
                challengeRequested: false,
                challenge,
            };
        }
        case SPECIFIC_CHALLENGE_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                challengeRequested: false,
            };
        }
        case CONNECTED_CHALLENGE_REQUESTED: {
            return {
                ...state,
                connectedChallengesLoading: true,
            };
        }
        case CONNECTED_CHALLENGE_SUCCEEDED: {
            const { challenges } = action;
            return {
                ...state,
                connectedChallengesLoading: false,
                connectedChallenges: challenges,
            };
        }
        case CONNECTED_CHALLENGE_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                connectedChallengesLoading: false,
            };
        }
        case CHALLENGE_CODES_REQUESTED: {
            return {
                ...state,
                challengeCodesLoading: true,
            };
        }
        case CHALLENGE_CODES_SUCCEEDED: {
            const { codes } = action;
            return {
                ...state,
                challengeCodesLoading: false,
                challengeCodes: codes,
            };
        }
        case CHALLENGE_CODES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                challengeCodesLoading: false,
            };
        }
        case CHALLENGE_NOTIFICATIONS_REQUESTED: {
            return {
                ...state,
                challengeNotificationsLoading: true,
            };
        }
        case CHALLENGE_NOTIFICATIONS_SUCCEEDED: {
            const { notifications } = action;
            return {
                ...state,
                challengeNotificationsLoading: false,
                notificationCurrentPage: state.notificationCurrentPage + 1,
                hasMoreNotifications:
                    notifications.length &&
                    notifications.length >= NOTIFICATION_LIMIT
                        ? true
                        : false,
                notifications: [...state.notifications, ...notifications],
            };
        }
        case CHALLENGE_NOTIFICATIONS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                challengeNotificationsLoading: false,
            };
        }
        case ADD_CHALLENGE_NOTIFICATION_REQUESTED: {
            return {
                ...state,
                addingNotification: true,
            };
        }
        case ADD_CHALLENGE_NOTIFICATION_SUCCEEDED: {
            const { notification } = action;
            return {
                ...state,
                addingNotification: false,
                notifications: [notification, ...state.notifications],
            };
        }
        case ADD_CHALLENGE_NOTIFICATION_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                addingNotification: false,
            };
        }
        case ADD_CHALLENGE_CODE_REQUESTED: {
            return {
                ...state,
                codeAddingError: '',
                error: null,
                addingNewCode: true,
            };
        }
        case ADD_CHALLENGE_CODE_SUCCEEDED: {
            return {
                ...state,
                codeAddingError: '',
                addingNewCode: false,
            };
        }
        case ADD_CHALLENGE_CODE_FAILED: {
            const { error } = action;
            return {
                ...state,
                codeAddingError: error,
                addingNewCode: false,
            };
        }
        case SET_PARENT_CHALLENGE: {
            const { parentChallenge } = action;
            return {
                ...state,
                parentChallenge,
            };
        }
        case CHALLENGE_NOTIFICATION_RESET: {
            return {
                ...state,
                notifications: [],
                notificationCurrentPage: 0,
            };
        }
        default:
            return state;
    }
}
